import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Header.scss';


// Images Export
import Logo from '../../images/Logo.svg';
import newLogo from '../../images/newlogo-orange.svg';
import { NavLink , useNavigate } from 'react-router-dom';


const Header = () => {

  const navigate = useNavigate();

  const [headerToggler , setHeaderToggler] = useState(false);

  const [scrollHeader ,  setScrollHeader] = useState(false)

  window.addEventListener("scroll", () => {
    if (window.pageYOffset > 150) {
      setScrollHeader(true)
    }
    if(window.pageYOffset <= 20) {
      setScrollHeader(false)
    }
  });


  return (
    <div className="Header">
      <div className="header-inner-section">
        <div className="container">
          <div className="grid grid-cols-12 header-grid-section items-center">
            <div className="left-logo-section col-span-4">
              <NavLink to={'/Home'}><img src={newLogo} alt="" /></NavLink>
            </div>
            <div className="right-menu-section desktop-header-menu-section col-span-8">
              <nav>
                <ul className='flex items-center justify-end gap-10'>
                  <li><NavLink to={'/Home'}>HOME</NavLink></li>
                  <li><NavLink to={'/About-Us'}>ABOUT US</NavLink></li>
                  <li><NavLink to={'/Services'}>SERVICES</NavLink></li>
                  {/* <li><NavLink to={'/Cargos'}>CARGOS</NavLink></li> */}
                  <li><NavLink to={'/Blogs'}>BLOG</NavLink></li>
                  <li>
                    <button className='flex items-center gap-4' onClick={() => navigate('ContactUs')}>
                      <i className="bi bi-telephone-fill"></i>
                      <p>Contact Us</p>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="mobile-header-menu-section col-span-6">
              <div className="mobile-menu-activator-section flex justify-end">
                  <button className={`three-dots-menu-section flex w-10 h-10 flex-col gap-2 justify-center ${headerToggler ? 'active' : 'non-active'}`} onClick={() => setHeaderToggler(!headerToggler)}>
                      <div className="similar-lines bg-[#0496FF] duration-500 h-1 w-full menu-line-1"></div>
                      <div className="similar-lines bg-[#0496FF] duration-500 h-1 w-full menu-line-2"></div>
                      <div className="similar-lines bg-[#0496FF] duration-500 h-1 w-full menu-line-3"></div>
                  </button>
              </div>
              <div className={`right-mobile-menu-fixed-section fixed duration-300 h-full w-[300px] z-[99] bg-white ${headerToggler ? 'right-0' : '-right-full opacity-0'} ${scrollHeader ? 'top-0 activer' : 'top-[117px]'}`}>
                  <div className="inner-mobile-menu">
                    <ul>
                      <li><NavLink to={'/'} className={'hover:bg-BlueTheme hover:text-white duration-300 w-full text-lg font-semibold'}>Home</NavLink></li>
                      <li><NavLink to={'/Services'} className={'hover:bg-BlueTheme hover:text-white duration-300 w-full text-lg font-semibold'}>Services</NavLink></li>
                      <li><NavLink to={'/About-Us'} className={'hover:bg-BlueTheme hover:text-white duration-300 w-full text-lg font-semibold'}>About Us</NavLink></li>
                      <li><NavLink to={'/Blogs'} className={'hover:bg-BlueTheme hover:text-white duration-300 w-full text-lg font-semibold'}>Blogs</NavLink></li>
                      <li><NavLink to={'/ContactUs'} className={'hover:bg-BlueTheme hover:text-white duration-300 w-full text-lg font-semibold'}>Contact Us</NavLink></li>
                    </ul>
                  </div>
              </div>
              <button onClick={() => setHeaderToggler(!headerToggler)} className={`left-mobile-menu-fixed-section fixed duration-300 h-full w-full bg-opacity-20 z-10 bg-black ${headerToggler ? 'left-0' : '-left-full opacity-0'}  ${scrollHeader ? 'top-0' : 'top-[117px]'}`}>

              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
